import { Box } from '@mui/material';
import styled from 'styled-components';

export const ImagesWrapper = styled(Box)`
  display: flex;
  gap: 20px;
  margin-top: 10px;
  width: 100%;
`;

export const StyledDrag = styled(Box)`
  position: relative;

  .take-ui {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: gray;
    z-index: 999;
    cursor: pointer;
  }
`;
